import { formatCentsExact } from './dashboard/dashboard-format'

interface ForfeitBalanceConfirmProps {
  /** Total balance in cents that deletion would destroy. */
  amountCents: number
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  /** Optional detail when the total spans several orgs. */
  scope?: string
}

/**
 * Acknowledgement shown before a deletion destroys a wallet balance.
 *
 * Shared by the user and startup delete dialogs: the backend refuses either
 * without `forfeitBalance`, so both need the same control and the same wording.
 */
export function ForfeitBalanceConfirm({
  amountCents,
  checked,
  onCheckedChange,
  scope,
}: ForfeitBalanceConfirmProps) {
  return (
    <label className="flex items-start gap-2 rounded border border-amber-500/30 bg-amber-500/5 px-3 py-2 text-sm">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onCheckedChange(e.target.checked)}
        className="mt-0.5 size-3.5"
      />
      <span>
        Forfeit <strong>{formatCentsExact(amountCents)}</strong> of wallet balance
        {scope ? ` ${scope}` : ''}. This money is not recoverable after deletion.
      </span>
    </label>
  )
}
